import {
  DockviewApi,
  DockviewReact,
  Orientation,
  themeAbyssSpaced,
} from "dockview";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SideBar from "../../components/SideBar/SideBar";
import Certificates from "../../pages/Certificates/Certificates";
import Companies from "../../pages/Companies/Companies";
import Dashboard from "../../pages/Dashboard/Dashboard";
import GlobalChat from "../../pages/GlobalChat/GlobalChat";
import OtherSettings from "../../pages/OtherSettings/OtherSettings";
import Posts from "../../pages/Posts/Posts";
import ReviewSpecialists from "../../pages/ReviewSpecialists/ReviewSpecialists";
import Sessions from "../../pages/Sessions/Sessions";
import Specialists from "../../pages/Specialists/Specialists";
import Users from "../../pages/Users/Users";

import "dockview-react/dist/styles/dockview.css";
import Courses from "../../pages/Courses/Courses";
import EducationHubs from "../../pages/EducationHubs/EducationHubs";
import FlexPass from "../../pages/FlexPass/FlexPass";
import MetaData from "../../pages/MetaData/MetaData";
import Publications from "../../pages/Publications/Publications";
import SessionPackages from "../../pages/SessionPackages/SessionPackages";
import ProjectFormPage from "../../pages/Projects/ProjectForm/ProjectFormPage";
import SystemQuizDesigner from "../../pages/SystemQuizzes/SystemQuizDesigner";
import SystemQuizzes from "../../pages/SystemQuizzes/SystemQuizzes";
import Webinars from "../../pages/Webinars/Webinars";
import Withdrawals from "../../pages/Withdrawals/Withdrawals";
import { openOrFocusRoutePanel } from "./dockPanelRouting";
import s from "./Main.module.css";

export const useRouteToDockPanel = (api: DockviewApi | undefined) => {
  const location = useLocation(),
    navigate = useNavigate();

  useEffect(() => {
    if (!api) return;

    openOrFocusRoutePanel(api, location.pathname);

    const disposable = api.onDidActivePanelChange((panel) => {
      if (!panel) return;
      location.pathname = `/${panel.id}`;
      navigate(`${location.pathname}${location.search}`, { replace: true });
      api.getPanel(panel.id)?.focus();
    });

    return () => disposable.dispose();
  }, [location.pathname, api, navigate]);
};

const components = {
  dashboard: () => <Dashboard />,
  users: () => <Users />,
  specialists: () => <Specialists />,
  "review-specialists": () => <ReviewSpecialists />,
  sessions: () => <Sessions />,
  companies: () => <Companies />,
  flexpass: () => <FlexPass />,
  posts: () => <Posts />,
  chat: () => <GlobalChat />,
  certificates: () => <Certificates />,
  "other-settings": () => <OtherSettings />,
  withdrawals: () => <Withdrawals />,
  "session-packages": () => <SessionPackages />,
  metadata: () => <MetaData />,
  webinars: () => <Webinars />,
  courses: () => <Courses />,
  publications: () => <Publications />,
  educationalHubs: () => <EducationHubs />,
  systemQuizzes: () => <SystemQuizzes />,
  systemQuizDesigner: () => <SystemQuizDesigner />,
  projectForm: () => <ProjectFormPage />,
};

const Main = () => {
  const [api, setApi] = useState<DockviewApi>();

  useRouteToDockPanel(api); // Hook to open panels on route

  return (
    <div className={s.container}>
      <div className={s.sideBarMenu}>
        <SideBar />
      </div>
      <div className={s.mainContent}>
        <DockviewReact
          theme={themeAbyssSpaced}
          components={components}
          onReady={(event) => {
            setApi(event.api);
            event.api.fromJSON({
              grid: {
                orientation: Orientation.HORIZONTAL,
                root: { type: "branch", data: [] },
                height: 100,
                width: 100,
              },
              panels: {},
            });
          }}
        />
      </div>
    </div>
  );
};

export default Main;
